<template>
  <modal
    :is-opened="isOpened"
    :on-close="close"
  >
    <template #header>
      {{ modalTitle }}
    </template>
    <template #body>
      <div class="modal-state">
        <p>{{ trans('offer.state.modal.delete.text') }}</p>
        <div class="modal-state__actions">
          <button
            class="btn btn--secondary"
            @click="close()"
          >
            {{ trans('global.cancel') }}
          </button>
          <button
            class="btn btn--primary modal-default-button confirm-button"
            @click="confirm()"
          >
            <span>{{ trans('global.confirm') }}</span>
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@components/Modal.vue';
import { showSubmitLoader } from '@atoms/spinner';
import { URL_HOME, URL_OFFER_ACTION_DELETE } from '@tools/routes/routes';
import { translationMixin } from '@elements/translation';
import { requestsMixin } from '@tools/requests-mixin';

/**
 * Delete Modal Component
 * This component use the modal component as a child.
 * It displays the delete offer form.
 */
export default {
  components: { Modal },
  mixins: [ translationMixin, requestsMixin ],
  props: {
    isOpened: { type: Boolean, default: false },
    offerHashId: { type: String, default: '' },
    redirectUrl: { type: String, default: '' },
  },
  data() {
    return {
      modalTitle: '',
      loading: false,
    };
  },
  watch: {
    isOpened(newVal) {
      if (!newVal) {
        return;
      }

      this.modalTitle = this.trans('offer.state.modal.delete.title');
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      if (!this.loading) {
        this.loading = true;
        const urlOfferDelete = URL_OFFER_ACTION_DELETE.replace('{id}', this.offerHashId);

        showSubmitLoader(this.$el.querySelector('.confirm-button'));

        this.get(urlOfferDelete).then(() => {
          const redirectUrl = this.redirectUrl || URL_HOME;
          window.location.href = redirectUrl;
        }).catch((result) => {
          const responseData = result.data;
          if (responseData.reload) {
            window.location.reload();
          }
        });
      }
    },
  },
};
</script>
